import React from 'react'
import HeroSection from './component/Herosection'
import FarmSection from './component/FarmSection'
import CrewSection from './component/CreawSection'
import JourneySection from './component/JourneySection'
import OurGoal from './component/OurGoal'

export default function About() {
  return (
    <div>
      <HeroSection />
      <FarmSection />
      <CrewSection />
      <JourneySection />
      <OurGoal /> 
    </div>
  )
}
